module.exports = __webpack_public_path__ + "static/media/license.b020a9e7.png";